import { UPLOAD_IMAGE_DATA } from '../actions/types';

const intialState = {
    uploadImageDatasource: [{
        imagePath: "",
        stepTitle: "",
        imageSize: "",
        upLoadStatus: "0",
        filename: "",
        type:"",
    }
    ],
};


export default (state = intialState, action) => {
    switch (action.type) {
        case UPLOAD_IMAGE_DATA:
            return {
                ...state,
                uploadImageDatasource: [...state.uploadImageDatasource, action.payload],
            };
        default:
            return state;
    }
}

